import React, { useState } from 'react';
import { Container, Row, Col, Form, Input, Label, Card, CardBody, Button } from 'reactstrap';
import FeatherIcon from 'feather-icons-react';
import { post } from '../helpers/api_helper';
import { toast } from 'react-toastify';
import { ErrorMessageDisplay } from '../../components/utils/common';
import { useAuth } from "../../store/auth";
import { formSection } from '../../data';
import { formSectionArabic } from '../../data/indexArabic';

const FormSection = () => {
  const { isArabic } = useAuth();
  const data = isArabic ? formSection : formSectionArabic;
  const defaultContactForm = { name: "", email: "", mobile: "", subject: "", comments: "" };
  const [form, setForm] = useState({ ...defaultContactForm, mobile: "+966" });
  const [formError, setFormError] = useState(defaultContactForm);
  const [loading, setLoading] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setForm(prevForm => ({ ...prevForm, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await post('/form', form);
      if (response?.ok) {
        toast.success("Your message was sent successfully.");
        setForm(defaultContactForm);
        setFormError(defaultContactForm);
      }
    } catch (error) {
      console.log(error);
      if (error) {
        setFormError(error);
        toast.error("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Container>
        <Row className="align-items-center">
          <Col lg={5} md={6} className="order-2 order-md-1 mt-4 mt-md-0">
            <Card className="shadow rounded-3 border-0">
              <CardBody className="py-5">
                <h4 className="card-title">{data?.title}</h4>
                <div className="custom-form mt-3">
                  <Form name="contact-form" onSubmit={handleSubmit}>
                    <Row>
                      {data?.formFields.map((field) => (
                        <Col md={field.name === 'name' || field.name === 'email' ? 6 : 12} key={field.name}>
                          <div className="mb-3">
                            <Label className={formError?.[field.name] ? "form-label text-danger" : "form-label"}>
                              {field.label} <span className="text-danger">*</span>
                            </Label>
                            <div className="form-icon position-relative">
                              <FeatherIcon icon={field.icon} className="fea icon-sm icons" />
                            </div>
                            {field.type === 'textarea' ? (
                              <textarea
                                name={field.name}
                                id={field.name}
                                rows="4"
                                className={`form-control ps-5 ${formError?.[field.name] ? 'is-invalid' : ''}`}
                                placeholder={field.placeholder}
                                value={form?.[field.name]}
                                required
                                onChange={handleInput}
                              />
                            ) : (
                              <Input
                                name={field.name}
                                id={field.name}
                                type={field.type}
                                className={`form-control ps-5 ${formError?.[field.name] ? 'is-invalid' : ''}`}
                                placeholder={field.placeholder}
                                value={form?.[field.name]}
                                onChange={handleInput}
                                required
                              />
                            )}
                            <ErrorMessageDisplay error={formError?.[field.name]} />
                          </div>
                        </Col>
                      ))}
                    </Row>
                    <Row>
                      <Col sm={12}>
                        <div className="d-grid">
                          <Button color="primary" type="submit" disabled={loading} className="rounded-pill">
                            {loading ? (
                              <>
                                Sending...
                                <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2"></i>
                              </>
                            ) : (
                              data?.btnText
                            )}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg={7} md={6} className="order-1 order-md-2">
            <Card className="border-0">
              <CardBody className="p-0">
                <img src={data?.img} className="img-fluid rounded-3 shadow-sm" alt="Contact Subul Contracting" />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
}

export default FormSection;